import React from 'react';

type Props = { children: React.ReactNode[] | React.ReactNode; condition?: boolean };

const IfCondition: React.FC<Props> = ({ condition, children }) => {
    if (!condition) return null;
    return <>{children}</>;
};

export default IfCondition;
